import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function(location) {
  return routerPush.call(this, location).catch(error => error)
}

import Login from '../views/login/login.vue' //登录页面
import Home from '../views/Home/Home.vue' //主页面

//系统设置
import SystemModule from '../components/systemSettings/systemModule.vue' //模块设置
import SystemRole from '../components/systemSettings/systemRole.vue' //角色管理
import SystemUser from '../components/systemSettings/systemUser.vue' //用户管理
import SystemCode from '../components/systemSettings/systemCode.vue' //系统代码
import SystemGlobal from '../components/systemSettings/systemGlobal.vue' //全局参数
import SystemCorporateAccount from '../components/systemSettings/systemCorporateAccount.vue' //企业账户
import SystemEnterpriseInformation from '../components/systemSettings/systemEnterpriseInformation.vue' //企业信息
import systemTransPriceRecordformation from '../components/systemSettings/systemTransPriceRecordformation.vue' //调价记录
import systemAbnormalOrder from '../components/systemSettings/systemAbnormalOrder.vue' //异常订单
import systemReportStatistics from '../components/systemSettings/systemReportStatistics.vue' //报表统计
import systemwlAdmin from '../components/systemSettings/systemwlAdmin.vue' //物料管理

import systemFeezeThawingRecord from '../components/systemSettings/systemFeezeThawingRecord.vue' //调价记录

//销售
import SalesCustomer from '../components/sales/salesCustomer.vue' //客户管理
import SalesBigCustomers from '../components/sales/salesBigCustomers.vue' //客户管理
import SalesCarManagement from '../components/sales/salesCarManagement.vue' //车辆管理
import SalesDeliveryPlace from '../components/sales/salesDeliveryPlace.vue' //配送地
import SalesBigDeliveryPlace from '../components/sales/salesBigDeliveryPlace.vue' //配送地--一级
import SalesMaterialPrice from '../components/sales/salesMaterialPrice.vue' //物料价格管理
import SalesPreferential from '../components/sales/salesPreferential.vue' //优惠管理
import SalesBillDetails from '../components/sales/salesBillDetails.vue' //账单明细表
import SalesFreightBillDetails from '../components/sales/salesFreightBillDetails.vue' //运费账单明细
import SalesDispatchManagement from '../components/sales/salesDispatchManagement.vue' //派单记录
import salesPrintVote from '../components/sales/salesPrintVote.vue' //流水记录
import SalesEntryOrder from '../components/sales/salesEntryOrder.vue' //派单记录
import SalesFinancialAudit from '../components/sales/salesFinancialAudit.vue' //财务审核
import PerformanceRecords from '../components/sales/performanceRecords.vue' //提现记录
import SalesDataAnalysis from '../components/sales/salesDataAnalysis.vue' //数据分析
import SalesCoupon from '../components/sales/salesCoupon.vue' //优惠券管理
import SalesOwnerExamine from '../components/sales/SalesOwnerExamine.vue' //车主审核
import SalesFreightOrder from '../components/sales/SalesFreightOrder.vue' //运费订单
import SalesFreightInformation from '../components/sales/SalesFreightInformation.vue' //运费信息
import salesslMaseg from '../components/sales/salesslMaseg.vue' //收料信息
import salesLssueOrder from '../components/sales/salesLssueOrder.vue' //一键发单
import salesPriceList from '../components/sales/salesPriceList.vue' //价格表
import salesBill from '../components/sales/salesBill.vue' //客户发票管理
import salesRecordExamine from '../components/sales/salesRecordExamine.vue' //客户发票审核
import salesCouponRecord from '../components/sales/salesCouponRecord.vue' //优惠券记录
import salesInvoice from '../components/sales/salesInvoice.vue' //厂家发票设置
import saleCustomerInvoice from '../components/sales/saleCustomerInvoice.vue' //客户发票管理
import saleInvoiceApproval from '../components/sales/saleInvoiceApproval.vue' //开票审核
import salesWaybillExamine from '../components/sales/salesWaybillExamine.vue' //财务审核
import billImportacion from '../components/sales/billImportacion.vue' //账单导入
import SaleQueryOfVehicleTrajectory from '../components/sales/saleQueryOfVehicleTrajectory.vue'
import freightAccount from '../components/sales/freightAccount.vue' // 运费收支明细
import waybillTrajectory from '../components/sales/waybillTrajectory.vue' // 运单轨迹
import rebateSetting from '../components/sales/rebateSetting.vue' // 返点设置
import receiptShippingOrder from '../components/sales/receiptShippingOrder.vue' //收料运费订单
import energyGoldDetail from '../components/sales/energyGoldDetail.vue' //能源金明细
//油站系统
import oilCardBill from '../components/serviceStation/oilCardBill.vue' //油卡
import oilCzInfo from '../components/serviceStation/oilCzInfo.vue' //油站充值记录
import oilStation from '../components/serviceStation/oilStation.vue' //油站
import stationStaff from '../components/serviceStation/stationStaff.vue' //油站员工管理
import SaleRate from '../components/serviceStation/saleRate/index.vue' //费率列表
import SaleRateDetail from '../components/serviceStation/saleRate/detail.vue' //费率详情

import bridge from '../components/serviceStation/bridge.vue' //电桩管理
import bridgeDetails from '../components/serviceStation/bridgeDetails.vue' //电桩详情
import chargingOrder from '../components/serviceStation/chargingOrder.vue' //充电订单
import chargingOrderDetails from '../components/serviceStation/chargingOrderDetails' //订单详情
import pileEquipment from '../components/serviceStation/pileEquipment.vue' //枪桩设备
import alarmInformation from '../components/serviceStation/alarmInformation.vue' //告警信息
import vehicleManagement from '../components/serviceStation/vehicleManagement.vue' //充电车辆管理
// 商砼站系统
import systemCommercialConcreteStand from '../components/systemSettings/systemCommercialConcreteStand.vue' //调价记录

//营销系统
import marKetingSet from '../components/marKeting/marKetingSet.vue' //营销系统-拉新记录
import marKetingLotteryRecord from '../components/marKeting/marKetingLotteryRecord.vue' //营销系统-拉新记录
import marKetingCoupon from '../components/marKeting/marKetingCoupon.vue' //营销系统-优惠券记录
import marKetingPointMsg from '../components/marKeting/marKetingPointMsg.vue' //营销系统-返点信息
import marketingFreightSubsidyRecords from '../components/marKeting/marketingFreightSubsidyRecords.vue'

//CRM系统
import CRMCustomer from '../components/CRM/CRMCustomer.vue' //客户管理
import CRMBillDetails from '../components/CRM/CRMBillDetails.vue' //账单明细表
import CRMPreferential from '../components/CRM/CRMPreferential.vue' //优惠管理
import oilCardExamine from '../components/CRM/oilCardExamine.vue' //油卡审核
import oilCardDivJoin from '../components/CRM/oilCardDivJoin.vue' //油卡预分配
import oilCardTrajectory from '../components/CRM/oilCardTrajectory.vue' //车辆轨迹
import CRMCarAdmin from '../components/CRM/CRMCarAdmin.vue' //车辆管理

//设备信息管理
import mortarTank from '../components/mortarTank/mortarTank.vue' //砂浆罐管理
// 数据看板
import mapBoard from '../components/dataBoard/mapBoard.vue' //地图可视化看板
import riskPerception from '../components/dataBoard/riskPerception.vue' //风险感知数据看板
import userStatistics from '../components/sales/userStatistics.vue'//用户统计

// 财务对账
import reconciliation from '../components/sales/reconciliation.vue' //财务对账
import phase from '../components/sales/phase.vue' //盈亏
import basePrice from '../components/sales/basePrice.vue'//厂家底价
Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/Login', //重定向
      component: Login,
    },
    {
      path: '/Login', //登录页面
      name: 'Login',
      component: Login,
    },
    {
      path: '/Home', //主页面
      name: 'Home',
      component: Home,
      children: [
        //子路由
        {
          path: 'SystemModule', //模块设置
          name: 'SystemModule',
          component: SystemModule,
        },
        {
          path: 'SystemRole', //角色管理
          name: 'SystemRole',
          component: SystemRole,
        },
        {
          path: 'SystemUser', //用户管理
          name: 'SystemUser',
          component: SystemUser,
        },
        {
          path: 'SystemCode', //系统代码
          name: 'SystemCode',
          component: SystemCode,
        },
        {
          path: 'SystemGlobal', //全局参数
          name: 'SystemGlobal',
          component: SystemGlobal,
        },
        {
          path: 'SystemCorporateAccount', //企业账户
          name: 'SystemCorporateAccount',
          component: SystemCorporateAccount,
        },

        {
          path: 'SystemEnterpriseInformation', //企业信息
          name: 'SystemEnterpriseInformation',
          component: SystemEnterpriseInformation,
        },
        {
          path: 'systemTransPriceRecordformation', //企业信息
          name: 'systemTransPriceRecordformation',
          component: systemTransPriceRecordformation,
        },
        {
          path: 'systemFeezeThawingRecord', //企业信息
          name: 'systemFeezeThawingRecord',
          component: systemFeezeThawingRecord,
        },
        {
          path: 'systemwlAdmin', //物料管理
          name: 'systemwlAdmin',
          component: systemwlAdmin,
        },

        {
          path: 'systemCommercialConcreteStand', //商砼站信息
          name: 'systemCommercialConcreteStand',
          component: systemCommercialConcreteStand,
        },

        {
          path: 'systemAbnormalOrder', //企业信息
          name: 'systemAbnormalOrder',
          component: systemAbnormalOrder,
        },
        {
          path: 'systemReportStatistics', //企业信息
          name: 'systemReportStatistics',
          component: systemReportStatistics,
        },

        {
          path: 'SalesCustomer', //客户管理
          name: 'SalesCustomer',
          component: SalesCustomer,
        },
        {
          path: 'SalesBigCustomers', //大客户管理
          name: 'SalesBigCustomers',
          component: SalesBigCustomers,
        },
        {
          path: 'SalesCarManagement', //车辆管理
          name: 'SalesCarManagement',
          component: SalesCarManagement,
        },
        {
          path: 'SaleQueryOfVehicleTrajectory', //车辆轨迹查询
          name: 'SaleQueryOfVehicleTrajectory',
          component: SaleQueryOfVehicleTrajectory,
        },
        {
          path: 'SalesDeliveryPlace', //配送地
          name: 'SalesDeliveryPlace',
          component: SalesDeliveryPlace,
        },
        {
          path: 'SalesBigDeliveryPlace', //配送地--一级
          name: 'SalesBigDeliveryPlace',
          component: SalesBigDeliveryPlace,
        },
        {
          path: 'SalesMaterialPrice', //物料价格管理
          name: 'SalesMaterialPrice',
          component: SalesMaterialPrice,
        },
        {
          path: 'SalesPreferential', //优惠管理
          name: 'SalesPreferential',
          component: SalesPreferential,
        },
        {
          path: 'SalesBillDetails', //账单明细表
          name: 'SalesBillDetails',
          component: SalesBillDetails,
        },
        {
          path: 'SalesFreightBillDetails', //运费账单明细
          name: 'SalesFreightBillDetails',
          component: SalesFreightBillDetails,
        },
        {
          path: 'SalesDispatchManagement', //派单记录
          name: 'SalesDispatchManagement',
          component: SalesDispatchManagement,
        },
        {
          path: 'salesPrintVote', //流水记录
          name: 'salesPrintVote',
          component: salesPrintVote,
        },

        {
          path: 'SalesEntryOrder', //录入
          name: 'SalesEntryOrder',
          component: SalesEntryOrder,
        },
        {
          path: 'SalesFinancialAudit', //财务审核
          name: 'SalesFinancialAudit',
          component: SalesFinancialAudit,
        },
        {
          path: 'PerformanceRecords', //提现记录
          name: 'PerformanceRecords',
          component: PerformanceRecords,
        },
        {
          path: 'SalesDataAnalysis', //数据分析
          name: 'SalesDataAnalysis',
          component: SalesDataAnalysis,
        },
        {
          path: 'SalesCoupon', //优惠券管理
          name: 'SalesCoupon',
          component: SalesCoupon,
        },
        {
          path: 'SalesOwnerExamine', //车主审核
          name: 'SalesOwnerExamine',
          component: SalesOwnerExamine,
        },
        {
          path: 'SalesFreightInformation', //运费信息
          name: 'SalesFreightInformation',
          component: SalesFreightInformation,
        },
        {
          path: 'salesslMaseg', //收料信息
          name: 'salesslMaseg',
          component: salesslMaseg,
        },

        {
          path: 'salesWaybillExamine', //运单审核
          name: 'salesWaybillExamine',
          component: salesWaybillExamine,
        },
        {
          path: 'billImportacion', //账单导入
          name: 'billImportacion',
          component: billImportacion,
        },

        {
          path: 'SalesFreightOrder', //运费订单
          name: 'SalesFreightOrder',
          component: SalesFreightOrder,
        },
        {
          path: 'salesLssueOrder', //一键发单
          name: 'salesLssueOrder',
          component: salesLssueOrder,
        },
        {
          path: 'salesPriceList', //价格表
          name: 'salesPriceList',
          component: salesPriceList,
        },
        {
          path: 'salesBill', //发票管理
          name: 'salesBill',
          component: salesBill,
        },
        {
          path: 'salesRecordExamine', //发票审核
          name: 'salesRecordExamine',
          component: salesRecordExamine,
        },

        {
          path: 'salesCouponRecord', //优惠券记录
          name: 'salesCouponRecord',
          component: salesCouponRecord,
        },
        {
          path: 'salesInvoice', //厂家发票设置
          name: 'salesInvoice',
          component: salesInvoice,
        },
        {
          path: 'oilCardBill', //油卡账单
          name: 'oilCardBill',
          component: oilCardBill,
        },
        {
          path: 'oilCzInfo', //油卡账单
          name: 'oilCzInfo',
          component: oilCzInfo,
        },
        {
          path: 'oilStation', //油卡账单
          name: 'oilStation',
          component: oilStation,
        },
        {
          path: 'stationStaff', //油站员工管理
          name: 'stationStaff',
          component: stationStaff,
        },
        {
          path: 'bridge', //电桩管理
          name: 'bridge',
          component: bridge,
          // children: [
          //   {
          //     path: "details", //电桩详情
          //     name: "bridgeDetails",
          //     component: bridgeDetails,
          //   },
          // ],
        },
        {
          path: 'bridgeDetails', //电桩详情
          name: 'bridgeDetails',
          component: bridgeDetails,
        },
        {
          path: 'saleCustomerInvoice', //客户发票管理
          name: 'saleCustomerInvoice',
          component: saleCustomerInvoice,
        },
        {
          path: 'saleInvoiceApproval', //开票审核
          name: 'saleInvoiceApproval',
          component: saleInvoiceApproval,
        },
        {
          path: 'marKetingSet', //营销系统-拉新记录
          name: 'marKetingSet',
          component: marKetingSet,
        },
        {
          path: 'marKetingLotteryRecord', //营销系统-抽奖记录
          name: 'marKetingLotteryRecord',
          component: marKetingLotteryRecord,
        },
        {
          path: 'marKetingCoupon', //营销系统-优惠券记录
          name: 'marKetingCoupon',
          component: marKetingCoupon,
        },
        {
          path: 'marketingFreightSubsidyRecords', //营销系统-优惠券记录
          name: 'marketingFreightSubsidyRecords',
          component: marketingFreightSubsidyRecords,
        },
        {
          path: 'marKetingPointMsg', //营销系统-优惠券记录
          name: 'marKetingPointMsg',
          component: marKetingPointMsg,
        },
        {
          path: 'CRMCustomer', //CRM-客户管理
          name: 'CRMCustomer',
          component: CRMCustomer,
        },
        {
          path: 'CRMBillDetails', //CRM-账单明细
          name: 'CRMBillDetails',
          component: CRMBillDetails,
        },
        {
          path: 'CRMPreferential', //CRM-优惠管理
          name: 'CRMPreferential',
          component: CRMPreferential,
        },
        {
          path: 'oilCardExamine', //CRM-油卡审核
          name: 'oilCardExamine',
          component: oilCardExamine,
        },
        {
          path: 'oilCardDivJoin', //CRM-油卡预分配
          name: 'oilCardDivJoin',
          component: oilCardDivJoin,
        },
        {
          path: 'oilCardTrajectory', //CRM-车辆轨迹
          name: 'oilCardTrajectory',
          component: oilCardTrajectory,
        },
        {
          path: 'CRMCarAdmin', //CRM-车辆管理
          name: 'CRMCarAdmin',
          component: CRMCarAdmin,
        },
        {
          path: 'mortarTank', //设备信息-砂浆罐管理
          name: 'mortarTank',
          component: mortarTank,
        },
        {
          path: 'SaleRate', //加油充电-费率列表
          name: 'SaleRate',
          component: SaleRate,
        },
        {
          path: 'SaleRateDetail', //加油充电-费率详情
          name: 'SaleRateDetail',
          component: SaleRateDetail,
        },
        {
          path: 'chargingOrder', //充电订单
          name: 'chargingOrder',
          component: chargingOrder,
        },
        {
          path: 'chargingOrderDetails', //订单详情
          name: 'chargingOrderDetails',
          component: chargingOrderDetails,
        },
        {
          path: 'pileEquipment', //枪桩设备
          name: 'pileEquipment',
          component: pileEquipment,
        },
        {
          path: 'alarmInformation', //告警信息
          name: 'alarmInformation',
          component: alarmInformation,
        },
        {
          path: 'freightAccount', //运费收支明细
          name: 'freightAccount',
          component: freightAccount,
        },
        {
          path: 'waybillTrajectory', //运单轨迹
          name: 'waybillTrajectory',
          component: waybillTrajectory,
        },
        {
          path: 'vehicleManagement', //充电车辆管理receiptShippingOrder
          name: 'vehicleManagement',
          component: vehicleManagement,
        },
        {
          path: 'rebateSetting', //返点设置
          name: 'rebateSetting',
          component: rebateSetting,
        },
        {
          path: 'receiptShippingOrder',
          name: 'receiptShippingOrder',
          component: receiptShippingOrder,
        },
        {
          path: 'energyGoldDetail',//能源金收支明细
          name: 'energyGoldDetail',
          component: energyGoldDetail,
        },
        {
          path:'mapBoard',//地图可视化看板
          name:'mapBoard',
          component:mapBoard
        },
        {
          path:'riskPerception',//风险感知数据看板
          name:'riskPerception',
          component:riskPerception
        },
        {
          path:'reconciliation',//财务对账
          name:'reconciliation',
          component:reconciliation
        },
        {
          path:'phase',//盈亏
          name:'phase',
          component:phase
        },
        {
          path:'basePrice',//厂家底价
          name:'basePrice',
          component:basePrice
        },
        {
          path:'userStatistics',//用户统计
          name:'userStatistics',
          component:userStatistics
        }
      ],
    },
  ],
})
router.beforeEach((to, from, next) => {
  if (to.path === '/Login') {
    return next()
  } else {
    var uobj = sessionStorage.getItem('token')
    if (!uobj) {
      next('/Login')
    } else {
      next()
    }
  }
})
export default router
